import BlogCard from "../components/blogs/blogcard";
import { items } from "./assets/blogsdata";
import "./assets/blogs.css";
const posts = [
  "australia",
  "japan_2024",
  "singapore",
  "vietnam",
  "malaysia",
  "japan_2023",
  "yantai",
];
export default function Blogs() {
  return (
    <section className="blogs-page">
      <header className="page-heading">
        <h1>Blogs</h1>
        <p>Notes from trips and places along the way.</p>
      </header>
      <div className="blogs-grid">
        {posts.map((key) => (
          <BlogCard key={key} info={items[key]} />
        ))}
      </div>
    </section>
  );
}
